<div class=" p-3" style="font-family: 'Mulish', sans-serif;"
  [ngClass]="{'documentos-historicos': selectedView === 'consulta', 'documentos-historicos2': selectedView !== 'consulta', 'pantalla-sm': selectedView !== 'consulta'}">
  <app-documentos-medicina-general [consulta]="consulta" [selectedView]="selectedView" [activeTab]="selectedTab"
    (selectedTabChange)="onSelectedTabChange($event)">
  </app-documentos-medicina-general>

</div>